import { defineMessages } from 'react-intl';

export default defineMessages({
  codeReviewerRepositoryOnError: {
    id: 'frontbucket.repository.settings.use-code-reviewer-setting.repository-on-error',
    description:
      'Error shown when attempting to turn Code Reviewer repository on.',
    defaultMessage:
      "Something went wrong and we couldn't turn Code Reviewer on in this repository, try again.",
  },
  codeReviewerRepositoryOffError: {
    id: 'frontbucket.repository.settings.use-code-reviewer-setting.repository-off-error',
    description:
      'Error shown when attempting to turn Code Reviewer repository off.',
    defaultMessage:
      "Something went wrong and we couldn't turn Code Reviewer off in this repository, try again.",
  },
  codeReviewerRepositoryAcceptanceCriteriaOnError: {
    id: 'frontbucket.repository.settings.use-code-reviewer-setting.repository-acceptance-critreia-on-error',
    description:
      'Error shown when attempting to turn Code Reviewer repository Acceptance Criteria on.',
    defaultMessage:
      "Something went wrong and we couldn't turn Code Reviewer Acceptance Criteria on in this repository, try again.",
  },
  codeReviewerRepositoryAcceptanceCriteriaOffError: {
    id: 'frontbucket.repository.settings.use-code-reviewer-setting.repository-acceptance-critreia-off-error',
    description:
      'Error shown when attempting to turn Code Reviewer repository Acceptance Criteria off.',
    defaultMessage:
      "Something went wrong and we couldn't turn Code Reviewer Acceptance Criteria off in this repository, try again.",
  },
  codeReviewerRepositoryAcceptanceCriteriaCommitTriggerOnError: {
    id: 'frontbucket.repository.settings.use-code-reviewer-setting.repository-acceptance-criteria-commit-trigger-on-error',
    description:
      'Error shown when attempting to turn Code Reviewer repository Acceptance Criteria Commit Trigger on.',
    defaultMessage:
      "Something went wrong and we couldn't turn Code Reviewer Acceptance Criteria Commit Trigger on in this repository, try again.",
  },
  codeReviewerRepositoryAcceptanceCriteriaCommitTriggerOffError: {
    id: 'frontbucket.repository.settings.use-code-reviewer-setting.repository-acceptance-criteria-commit-trigger-off-error',
    description:
      'Error shown when attempting to turn Code Reviewer repository Acceptance Criteria Commit Trigger off.',
    defaultMessage:
      "Something went wrong and we couldn't turn Code Reviewer Acceptance Criteria Commit Trigger off in this repository, try again.",
  },
  codeReviewerWorkspaceOnError: {
    id: 'frontbucket.repository.settings.use-code-reviewer-setting.workspace-on-error-message',
    description:
      'Error shown when attempting to turn Code Reviewer on for a workspace',
    defaultMessage:
      "Something went wrong and we couldn't turn Code Reviewer on in this workspace, try again.",
  },
  codeReviewerWorkspaceOffError: {
    id: 'frontbucket.repository.settings.use-code-reviewer-setting.workspace-off-error-message',
    description:
      'Error shown when attempting to turn Code Reviewer off for a workspace',
    defaultMessage:
      "Something went wrong and we couldn't turn Code Reviewer off in this workspace, try again.",
  },
  codeReviewerGenericGetError: {
    id: 'frontbucket.repository.settings.use-code-reviewer-setting.get-error',
    description:
      'Error shown when attempting to find the Code Reviewer repository setting.',
    defaultMessage: 'Something went wrong, try again.',
  },
});
